import {ConstraintsBuilder} from './constraints-builder';

let Factory = {
    getBuilder() {
        return ConstraintsBuilder;
    },
};

export {Factory};
